import { render } from "./SearchDetail.vue?vue&type=template&id=9b9fb5dc&scoped=true&ts=true"
import script from "./SearchDetail.vue?vue&type=script&lang=ts"
export * from "./SearchDetail.vue?vue&type=script&lang=ts"

import "./SearchDetail.vue?vue&type=style&index=0&id=9b9fb5dc&lang=scss&scoped=true"
import "./SearchDetail.vue?vue&type=style&index=1&id=9b9fb5dc&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b9fb5dc"],['__file',"shared/src/entidades/builder/crud/infrastructure/search/SearchDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9b9fb5dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9b9fb5dc', __exports__)) {
    api.reload('9b9fb5dc', __exports__)
  }
  
  module.hot.accept("./SearchDetail.vue?vue&type=template&id=9b9fb5dc&scoped=true&ts=true", () => {
    api.rerender('9b9fb5dc', render)
  })

}


export default __exports__